import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ShInputComponent } from '@seahorse/components';

/** The non-empty, trimmed parts of a comma-separated text. */
export function parseCsv(text: string | null | undefined): string[] {
  return (text ?? '')
    .split(',')
    .map((part) => part.trim())
    .filter((part) => part.length > 0);
}

function sameList(a: readonly string[], b: readonly string[]): boolean {
  return a.length === b.length && a.every((value, index) => value === b[index]);
}

/**
 * A list of strings typed as comma-separated text (`values` is the list,
 * `valuesChange` emits it on every keystroke): the free-text replacement for
 * the old free-entry tag selects. The text is kept while the user types, so a
 * trailing comma is not eaten when the parent writes the parsed list back.
 *
 *   <su-csv-input [(values)]="item.requestedFields" />
 */
@Component({
  selector: 'su-csv-input',
  imports: [ShInputComponent],
  template: `
    <sh-input
      [value]="text"
      [placeholder]="placeholder"
      [disabled]="disabled"
      [ariaLabel]="ariaLabel"
      (valueChange)="onText($event)"
    ></sh-input>
  `,
})
export class CsvInputComponent {
  @Input() placeholder = '';
  @Input() ariaLabel?: string;
  @Input() disabled = false;

  @Input() set values(values: string[] | null | undefined) {
    // Only rewrite the text when the list really differs from what it parses
    // to (the parent echoes back what this control just emitted).
    if (!sameList(parseCsv(this.text), values ?? [])) {
      this.text = (values ?? []).join(', ');
    }
  }
  @Output() valuesChange = new EventEmitter<string[]>();

  text = '';

  onText(value: string | null) {
    this.text = value ?? '';
    this.valuesChange.emit(parseCsv(this.text));
  }
}
